import React from 'react';
import { Phone, ArrowRight, Star } from 'lucide-react';
import { business, heroImage, heroGallery } from '../mock';
import Marquee from './Marquee';

export default function Hero({ onSchedule }) {
  return (
    <section id="home" className="relative">
      {/* Hero image band */}
      <div className="relative" style={{ paddingTop: 74 }}>
        <div className="relative overflow-hidden" style={{ minHeight: 620 }}>
          <img
            src={heroImage}
            alt="A caregiver and senior enjoying a walk together in a sunlit garden"
            className="absolute inset-0 w-full h-full object-cover hero-zoom"
          />
          <div
            className="absolute inset-0"
            style={{ background: 'linear-gradient(90deg, rgba(20,42,31,0.72) 0%, rgba(20,42,31,0.35) 55%, rgba(20,42,31,0.15) 100%)' }}
          />
          <div className="absolute bottom-0 left-0 right-0 h-28" style={{ background: 'linear-gradient(180deg, rgba(251,248,241,0) 0%, var(--cream) 96%)' }} />

          <div className="container-x relative" style={{ minHeight: 620 }}>
            <div className="flex flex-col justify-center h-full" style={{ minHeight: 620 }}>
              <div className="max-w-[720px] py-16">
                <p className="eyebrow mb-3 hero-rise" style={{ color: '#DDEBAF', animationDelay: '0.15s' }}>Dallas &ndash; Fort Worth Home Care</p>
                <h1 className="text-white font-serif-display hero-rise" style={{ fontSize: 'clamp(2.6rem, 5.6vw, 4.6rem)', color: '#fff', animationDelay: '0.3s' }}>
                  Inspired Home Care<br />for Those You Love
                </h1>
                <p className="text-white/90 mt-6 text-lg max-w-[560px] hero-rise" style={{ animationDelay: '0.5s' }}>
                  With caregivers who feel like family, Mom&rsquo;s Best Friend Senior Care delivers
                  acclaimed in-home care in North Dallas &amp; Fort Worth &mdash; helping your loved one stay
                  safe, comfortable, and happy in the home they love.
                </p>
                <div className="flex flex-wrap items-center gap-4 mt-9 hero-rise" style={{ animationDelay: '0.68s' }}>
                  <button className="btn-sage" onClick={onSchedule}>
                    Schedule a Care Consultation <ArrowRight size={18} />
                  </button>
                  <a href={business.phoneHref} className="btn-ghost-light">
                    <span className="flex items-center justify-center rounded-full" style={{ width: 38, height: 38, backgroundColor: 'rgba(255,255,255,0.18)' }}>
                      <Phone size={17} />
                    </span>
                    Call {business.phone}
                  </a>
                </div>

                <div className="flex flex-wrap items-center gap-x-6 gap-y-3 mt-10 hero-rise" style={{ animationDelay: '0.85s' }}>
                  <div className="flex items-center gap-2">
                    <div className="flex">
                      {[0,1,2,3,4].map((i) => (
                        <Star key={i} size={18} fill="#F3E27A" color="#F3E27A" />
                      ))}
                    </div>
                    <span className="text-white font-semibold">{business.rating}</span>
                    <span className="text-white/70 text-sm">on Google &amp; Facebook</span>
                  </div>
                  <div className="h-8 w-px bg-white/25" />
                  <div>
                    <div className="text-white font-serif-display text-2xl leading-none" style={{ color: '#fff' }}>Since {business.since}</div>
                    <div className="text-white/70 text-sm">Serving DFW families</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery strip of arched images */}
      <div className="container-x -mt-4 relative z-10">
        {/* Desktop / tablet: grid */}
        <div className="hidden md:grid grid-cols-3 lg:grid-cols-6 gap-4">
          {heroGallery.map((src, i) => (
            <div
              key={i}
              className="overflow-hidden"
              style={{ borderRadius: '120px 120px 16px 16px', aspectRatio: '3/4' }}
            >
              <img src={src} alt="Seniors and caregivers sharing joyful moments at home" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
            </div>
          ))}
        </div>

        {/* Mobile: auto-scroll marquee (CSS transform, pauses on touch/hover) */}
        <div className="md:hidden">
          <Marquee
            items={heroGallery}
            itemWidth={150}
            gap={16}
            durationSec={26}
            renderItem={(src) => (
              <div
                className="overflow-hidden w-full"
                style={{ borderRadius: '120px 120px 16px 16px', aspectRatio: '3/4' }}
              >
                <img src={src} alt="Seniors and caregivers sharing joyful moments at home" className="w-full h-full object-cover" />
              </div>
            )}
          />
        </div>
      </div>
    </section>
  );
}
